import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EventCategory, } from "../apiPath/api";

export const createEventCategory = createAsyncThunk(
  "eventCategory/createEventCategory",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await EventCategory.createEventCategory(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllEventCategories = createAsyncThunk(
  "eventCategory/getAllEventCategories",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await EventCategory.getAllEventCategories(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deleteEventCategory = createAsyncThunk(
  "eventCategory/deleteEventCategories",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await EventCategory.deleteEventCategory(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeleteEventCategory = createAsyncThunk(
  "eventCategory/undoDeleteEventCategory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EventCategory.undoDeleteEventCategory(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updateEventCategory = createAsyncThunk(
  "eventCategory/updateEventCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await EventCategory.updateEventCategory(id, data);
      return response.data;
    } catch (error) {
      console.error("Update error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update event category"
      );
    }
  }
);

const eventCategorySlice = createSlice({
  name: "eventCategory",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    eventCategory: [],
  },

  reducers: {
    resetEventCategoryState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.eventCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEventCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createEventCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createEventCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllEventCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllEventCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.eventCategory = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllEventCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEventCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEventCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteEventCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeleteEventCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeleteEventCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeleteEventCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEventCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateEventCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updateEventCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetEventCategoryState } = eventCategorySlice.actions;
export default eventCategorySlice.reducer;
